import { render, staticRenderFns } from "./DepotView.vue?vue&type=template&id=2d59f632"
import script from "./DepotView.vue?vue&type=script&lang=ts"
export * from "./DepotView.vue?vue&type=script&lang=ts"
import style0 from "./DepotView.vue?vue&type=style&index=0&id=2d59f632&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports